<template>
  <div id="guide-supplier-list">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h6>Partners</h6>
      </div>
    </div>

    <template v-if="suppliers">
      <div class="md=layout">
        <div class="md-layout-item md-size-100">
          <md-table>
            <md-table-row v-for="supplier in suppliers" :key="supplier.id">
              <md-table-cell>{{ supplier.company }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["suppliers"]
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#guide-supplier-list {
  margin-top: 1rem;
  border-top: 2px solid $brand-primary;
  padding-top: 1rem;

  .md-table-cell {
    padding: 4px 4px 4px 0;
    height: 36px;
  }

  h6,
  .h6 {
    margin: 0 0 0.5rem 0;
  }
}
</style>
